import { album } from './album.model';
export class media {
  id: number;
  title: string;
  album: album;
  path: string;
  type: string;
  access: boolean;
  price: number;
  ordering: number;
  playing: boolean;
}



// WEBPACK FOOTER //
// ./src/models/media.model.ts